import React, { useState } from 'react';
import DocsInputNew from '../../../../components/Inputs/DocsInput/DocsInputNew';
import HookForm from '../../../../components/HookForm/HookForm';
import {
  CAR_DOC_TYPE_PURCHASE_CONTRACT,
  CAR_DOC_TYPE_INSPECTION_ACT,
  CAR_DOC_TYPE_PHOTOS,
  CAR_DOCUMENT_TYPE_MAP
} from '../../../../constants/carDocumentTypes';

const DocumentsForm = ({ onSubmit, currentData, carId }) => {
  const [documentsForm, setDocumentsForm] = useState([
    {
      text: CAR_DOCUMENT_TYPE_MAP[CAR_DOC_TYPE_PURCHASE_CONTRACT],
      label: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ ÑÐ°Ð¹Ð» Ð´Ð¾Ð³Ð¾Ð²Ð¾ÑÐ°',
      name: String(CAR_DOC_TYPE_PURCHASE_CONTRACT),
      component: DocsInputNew,
      accept: '.pdf,.doc,.docx',
      hint: 'ÐÐ°Ð³ÑÑÐ·Ð¸ÑÐµ Ð´Ð¾Ð³Ð¾Ð²Ð¾Ñ Ð² ÑÐ¾ÑÐ¼Ð°ÑÐµ PDF Ð¸Ð»Ð¸ Word',
      rules: { required: true },
      id: CAR_DOC_TYPE_PURCHASE_CONTRACT,
      defaultValue: currentData?.[CAR_DOC_TYPE_PURCHASE_CONTRACT],
    },
    {
      text: CAR_DOCUMENT_TYPE_MAP[CAR_DOC_TYPE_INSPECTION_ACT],
      label: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ ÑÐ°Ð¹Ð» Ð°ÐºÑÐ°',
      name: String(CAR_DOC_TYPE_INSPECTION_ACT),
      component: DocsInputNew,
      accept: '.pdf,.doc,.docx',
      hint: 'ÐÐ°Ð³ÑÑÐ·Ð¸ÑÐµ Ð°ÐºÑ Ð¿ÑÐ¸ÑÐ¼ÐºÐ¸ Ð² ÑÐ¾ÑÐ¼Ð°ÑÐµ PDF Ð¸Ð»Ð¸ Word',
      rules: { required: true },
      id: CAR_DOC_TYPE_INSPECTION_ACT,
      defaultValue: currentData?.[CAR_DOC_TYPE_INSPECTION_ACT],
    },
    {
      text: CAR_DOCUMENT_TYPE_MAP[CAR_DOC_TYPE_PHOTOS],
      label: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ ÑÐ°Ð¹Ð»',
      name: String(CAR_DOC_TYPE_PHOTOS),
      component: DocsInputNew,
      accept: '.pdf,.doc,.docx,.jpg,.png,.jpeg',
      hint: 'Ð¤Ð¾ÑÐ¾Ð³ÑÐ°ÑÐ¸Ð¸ Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ Ð² ÑÐ¾ÑÐ¼Ð°ÑÐµ PDF Ð¸Ð»Ð¸ Word',
      rules: { required: true },
      id: CAR_DOC_TYPE_PHOTOS,
      defaultValue: currentData?.[CAR_DOC_TYPE_PHOTOS],
      multiple: true,
    },
  ]);

  const handleSubmit = async (values) => {
    // ÐÑÐ¾Ð²ÐµÑÑÐµÐ¼, ÑÑÐ¾ Ð²ÑÐµ Ð¾Ð±ÑÐ·Ð°ÑÐµÐ»ÑÐ½ÑÐµ Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÑ Ð·Ð°Ð³ÑÑÐ¶ÐµÐ½Ñ
    const requiredDocs = [
      String(CAR_DOC_TYPE_PURCHASE_CONTRACT),
      String(CAR_DOC_TYPE_INSPECTION_ACT),
      String(CAR_DOC_TYPE_PHOTOS),
    ];
    const missingDocs = requiredDocs.filter((docId) => !values[docId]);

    if (missingDocs.length > 0) {
      const missingLabels = missingDocs.map((docId) => CAR_DOCUMENT_TYPE_MAP[docId] || docId);
      alert.error(`ÐÐµÐ¾Ð±ÑÐ¾Ð´Ð¸Ð¼Ð¾ Ð·Ð°Ð³ÑÑÐ·Ð¸ÑÑ ÑÐ»ÐµÐ´ÑÑÑÐ¸Ðµ Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÑ: ${missingLabels.join(', ')}`);
      return;
    }

    onSubmit(values);
  };

  return (
    <div style={{ padding: 20 }}>
      <HookForm
        inputs={documentsForm}
        title={'ÐÐ°Ð³ÑÑÐ·ÐºÐ° Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ¾Ð² Ð²ÑÐºÑÐ¿Ð°'}
        grid={{ display: 'grid', gap: '20px', gridTemplateColumns: '1fr' }}
        handlerSetState={setDocumentsForm}
        onSubmit={handleSubmit}
        action={'Ð¡Ð¾ÑÑÐ°Ð½Ð¸ÑÑ'}
        border
      />
    </div>
  );
};

export default DocumentsForm;
